import React from 'react'
import { useStateContext } from 'provider/StateProvider'
import { RiskPanel } from 'components/RiskPanel'


export const DosyaPanel = () => {
  const state = useStateContext()

  const content: string = React.useMemo(() => {
    if (state.risks) {
      const dosya = state.risks.find(r => r.name.startsWith('土砂災害警戒区域') && r.value !== '')
      if (dosya !== undefined) {
        return '土砂災害警戒区域: 区域内'
      }
    }
    return '土砂災害警戒区域：区域外'
  }, [state.risks])

  return (
    <>
      <RiskPanel title='土砂災害' content={content} backgroundColor='#f7c885' color='#cb821a' />
    </>
  )
}
